<div class="leads-container">
  <div class="leads-header">
    <h1 class="page-title">Leads</h1>
  </div>

  <!-- Search and Filter Bar -->
  <div class="search-filter-bar">
    <div class="search-input-wrapper">
      <input
        type="text"
        class="search-input"
        placeholder="Search by Product ID or Product Name"
        [(ngModel)]="searchTerm"
        (input)="onSearch()">
      <svg class="search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="9" cy="9" r="6" stroke="#6b7280" stroke-width="1.5"/>
        <path d="M14 14L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round"/>
      </svg>
    </div>
    
    <select class="filter-select" [(ngModel)]="selectedCategory" (change)="onCategoryChange()">
      <option value="">Filter by Product Category</option>
      <option *ngFor="let cat of categories" [value]="cat.name">{{ cat.name }}</option>
    </select>
    
    <select class="filter-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
      <option value="">Filter by Status</option>
      <option value="Yet to Quote">Yet to Quote</option>
      <option value="Expired">Expired</option>
    </select>
    
    <button class="btn-reset" (click)="resetFilters()">Reset</button>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="error-message">
    {{ errorMessage }}
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <p>Loading leads...</p>
  </div>

  <!-- Leads Table -->
  <div *ngIf="!loading && !errorMessage" class="table-container">
    <table class="leads-table">
      <thead>
        <tr>
          <th>Product ID</th>
          <th>Product Name</th>
          <th>Status</th>
          <th>Timeline (DD/MM/YYYY)</th>
          <th>Shipping Term</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let lead of filteredLeads" (click)="viewLeadDetails(lead)" class="table-row-clickable">
          <td class="product-id">{{ lead.product?.productId || '-' }}</td>
          <td class="product-name">
            <div class="product-name-text">{{ lead.product?.name || '-' }}</div>
            <div class="product-category" *ngIf="lead.product?.category?.name">
              Product Category: {{ lead.product.category.name }}
            </div>
          </td>
          <td>
            <span class="status-badge" [ngClass]="getStatusClass(lead.status)">
              {{ lead.status }}
            </span>
          </td>
          <td class="timeline">
            <div class="timeline-item">
              <span class="timeline-label">Shared on :</span>
              <span class="timeline-value">{{ formatDate(lead.sharedOn || lead.createdAt) }}</span>
            </div>
            <div class="timeline-item">
              <span class="timeline-label" *ngIf="lead.status === 'Expired' || lead.submittedAt">Quoted on :</span>
              <span class="timeline-label" *ngIf="lead.status !== 'Expired' && !lead.submittedAt">Due on :</span>
              <span class="timeline-value">
                <span *ngIf="lead.submittedAt">{{ formatDate(lead.submittedAt) }}</span>
                <span *ngIf="!lead.submittedAt">{{ formatDate(lead.quoteDueDate || lead.product?.quoteSubmissionDueDate) }}</span>
              </span>
            </div>
          </td>
          <td class="shipping-term">
            <div class="shipping-term-text">{{ getShippingTerm(lead) }}</div>
            <div class="shipping-address">{{ getShippingAddress(lead) }}</div>
          </td>
        </tr>
        <tr *ngIf="filteredLeads.length === 0">
          <td colspan="5" class="no-data">No leads found</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
